import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Container, Link, Stack, Typography } from '@mui/material';
import logo from '../../assets/logo-symbol.svg';

const Footer = () => (
  <Box component="footer" sx={{ mt: 'auto', py: 3, borderTop: 1, borderColor: 'divider', bgcolor: 'background.paper' }}>
    <Container maxWidth="xl">
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={1.5}
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        justifyContent="space-between"
      >
        <Stack direction="row" spacing={1.25} alignItems="center">
          <Box component="img" src={logo} alt="" sx={{ height: 28, width: 'auto' }} />
          <Box>
            <Typography variant="subtitle2" sx={{ lineHeight: 1.2 }}>
              MangroveCollect
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Field data for mangrove monitoring
            </Typography>
          </Box>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center">
          <Link component={RouterLink} to="/help" variant="caption" color="text.secondary">
            User guide
          </Link>
          <Typography variant="caption" color="text.secondary">
            © {new Date().getFullYear()} MangroveCollect
          </Typography>
        </Stack>
      </Stack>
    </Container>
  </Box>
);

export default Footer;
